module.exports = __webpack_public_path__ + "img/mStamp.1e8664e2.svg";